module.exports = __webpack_public_path__ + "static/media/rsz_fpb_-_logo_-_hd_mogljv.9dfc5d66.png";